module.exports = __webpack_public_path__ + "static/media/loader2.b231380c.gif";